export function getDaysRemaining(enddate,criteriaDate) {
  if (!enddate) return null;

  const end = new Date(enddate);
  const now = new Date();
  const diffMs = end - now;

  if (diffMs <= 0) return 0;

  const daysleft =  Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  if(criteriaDate && daysleft < criteriaDate) {
    return daysleft;
  } 
}

export const ISODateFormate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}